import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'


import cesiumViewer from '@/components/cesiumViewer'
import portada from '@/components/portada'
import aplicacion from '@/components/aplicacion'
import registro from '@/components/registro'
import about from '@/components/about'
import login from '@/components/login'
import gestion from '@/components/gestion'
import panel from '@/components/panel'
import formularioArea from '@/components/formularioArea'
import formulario from '@/components/formulario'
import formularioVisitante from '@/components/formularioVisitante'



Vue.use(Router)


const router = new Router({
  routes: [
    {
      path: '/',
      name: 'portada',
      component: portada
    },
    {
      path: '/aplicacion',
      name: 'aplicacion',
      component: aplicacion,
      children: [
        { path: '/',
          component: cesiumViewer,
          name: cesiumViewer 
        },
        { path: '/aplicacion/:opcion',
          component: cesiumViewer,
          name: cesiumViewer 
        },

        // ...other sub routes
      ]
    },
    {
      path: '/registro',
      name: 'registro',
      component: registro
    },
    {
      path: '/login',
      name: 'login',
      component: login
    },
    {
      path: '/about/:doc',
      name: 'about',
      component: about
    },
    {
      path: '/gestion',
      name: 'gestion',
      beforeEnter: (to, from, next) => {
        if (!store.state.login) { /// THIS NOT WORK, HOW TO ACCESS STORE?
          next('/')
        } else {
          next()
        }
      },
      component: gestion,
      children: [
        { path: '/',
          component: panel,
          name: panel 
        },
        { path: 'formulario',
          component: formulario,
          name: formulario 
        },
        { path: 'formularioArea',
          component: formularioArea,
          name: formularioArea 
        },
        { path: 'formularioVisitante',
          component: formularioVisitante,
          name: formularioVisitante 
        },
      ]
    },
  ]
})


/*

router.beforeEach((gestion,from, next) => {
  console.log("-----")
  console.log(store.state.login)
  if (!store.state.login) { /// THIS NOT WORK, HOW TO ACCESS STORE?
    next('/')
  } else {
    next()
  }
})
*/



export default router



// WEBPACK FOOTER //
// ./src/router/index.js